import { motion } from "framer-motion";
import { maskReveal } from "@/lib/motion";

/**
 * RevealLines: splits an array of strings into masked lines and animates them upward on mount.
 */
export function RevealLines({ lines, className = "", element: El = "h1", delay = 0 }) {
  return (
    <El className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            variants={maskReveal}
            initial="hidden"
            animate="show"
            custom={i + delay}
            style={{ display: "inline-block" }}
            dangerouslySetInnerHTML={{ __html: line }}
          />
        </span>
      ))}
    </El>
  );
}

/**
 * RevealOnScroll: masked reveal triggered when element enters view.
 */
export function RevealOnScroll({ lines, className = "", element: El = "h2" }) {
  return (
    <El className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.95, ease: [0.76, 0, 0.24, 1], delay: i * 0.08 }}
            style={{ display: "inline-block" }}
            dangerouslySetInnerHTML={{ __html: line }}
          />
        </span>
      ))}
    </El>
  );
}
